export enum REPORTING_FIELD_LIST {
  NAME = 'name',
  COUNTRY = 'country',
  LOCATION = 'location',
  BUILDING = 'building',
  FLOOR = 'floor',
  WIRELESS_SYSTEM = 'wireless system',
  TYPE = 'type',
  NUMBER_OF_DEVICES = 'number of devices',
  RESPONSIBLE_UNIT = 'responsible units',
  STATUS = 'status',
  DESCRIPTION = 'description',
  MANUFACTURER = 'manufacturer',
  MODEL_NAME = 'model name',
  DRAFT = 'draft',
  OUTDOOR = 'outdoor',
  HEIGHT = 'height',
  AXIS = 'axis',
  ROOM = 'room',
  IMPLEMENTATION_START = 'implementation start date',
  IMPLEMENTATION_END = 'implementation end date',
  EXPIRATION_DATE = 'expiration date',
  OWNERS = 'owners',
  OPERATORS = 'operators',
  FREQUENCY_MANAGERS = 'frequency managers',
  REQUESTER = 'requester',
  LAST_UPDATED_BY = 'last updated by',
  LAST_UPDATED_AT = 'last updated at',
  INTERFACE = 'interface',
  BANDWIDTH = 'bandwidth',
  MAX_EIRP = 'max eirp',
  CHANNEL_SELECTION = 'channel selection',
  CHANNEL_NUMBER = 'channel number',
  CHANNEL_CENTRAL_FREQUENCY = 'channel central frequency',
  CHANNEL_EIRP = 'channel eirp',
}